const company = {
  name: "eatabit",
  contactEmail: "hey@eatabit.com",
};

export { company };
